import { render, staticRenderFns } from "./TableListAim.vue?vue&type=template&id=2df895bd&"
import script from "./TableListAim.vue?vue&type=script&lang=ts&"
export * from "./TableListAim.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports